import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'

import partnerConfigReducers from '@/redux/partnerConfig/reducers'
import productConfigReducers from '@/redux/productConfig/reducers'
import userConfigReducers from '@/redux/userConfig/reducers'
import auth0ConfigReducers from '@/redux/auth0Config/reducers'
import userProfileReducers from '@/redux/userProfile/reducers'
import signupStateReducers from '@/redux/signup/reducers'
import regionInfoReducers from '@/redux/regionInfo/reducers'
import appMessageReducers from '@/redux/appMessage/reducers'

const reducers = combineReducers({
  partnerConfig: partnerConfigReducers,
  productConfig: productConfigReducers,
  userConfig: userConfigReducers,
  auth0Config: auth0ConfigReducers,
  userProfile: userProfileReducers,
  signupState: signupStateReducers,
  regionInfo: regionInfoReducers,
  appMessage: appMessageReducers,
})

const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: ['userConfig', 'userProfile'],
}

export default persistReducer(persistConfig, reducers)
